/* 这里数据请求的唯一入口 */
import login from './login/index.js'
import role from './system/role.js'
import user from './system/user'
import dept from './system/dept'
import menu from './system/menu'
import dict from './system/dict'
import router from './router'
import district from './device/district'
import barcode from './device/barcode'
import version from './device/versions'
import recycletype from './device/recycletype'
import rejectiontype from './device/rejectiontype'
import project from './system/project'
import transaction from './device/transaction'
import locationType from './device/locationType'
import errorType from './device/errortype'
import faultManagement from './device/faultManagement'
import machine from './device/machine'
import TransCheck from './Device_info/Transaction_record_checking'
import logout from './logout/index'
import repairrecord from './device/repairrecord'
import email from './notification/email'
import cleaning from './device/cleaning'
import empty from './device/emptyrecord'
import overflow from './notification/overflow'
import map from './map/map'
import AlipayDeal from './Alipay/AlipayDeal'
import AlipayUser from './Alipay/AlipayUser'
import DidiUser from './DidiReward/DidiUser.js'
import DidiDeal from './DidiReward/DidiDeal.js'
import charityOrganization from './charityOrganization/index.js'
import ad from './ad'
import adModel from './ad/adModel'
import platform from './PayCenter'
import cd from "./CD"
import analysis from './analysis/index.js'
import language from './language/index.js'
import api from './logManage/api'
import dataModule from './Device_info/dataModule'
import deptMachine from './deptMachine/index'
export default {
    login,
    role,
    user,
    dept,
    menu,
    dict,
    router,
    district,
    barcode,
    version,
    recycletype,
    rejectiontype,
    project,
    transaction,
    locationType,
    errorType,
    faultManagement,
    machine,
    TransCheck,
    logout,
    repairrecord,
    email,
    cleaning,
    empty,
    overflow,
    map,
    AlipayDeal,
    AlipayUser,
    DidiUser,
    DidiDeal,
    charityOrganization,
    ad,
    adModel,
    platform,
    cd,
    analysis,
    language,
    api,
    dataModule,
    deptMachine
}